export function stripLeadingChar(text, char) {
  if (text.startsWith(char)) return text.substring(1);else return text;
}
export function stripTrailingChar(text, char) {
  if (text.endsWith(char)) return text.substring(0, text.length - 1);else return text;
}